import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import API from "../api/axios";
import { toast } from "react-toastify";

const RoleProtected = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!token || token === "undefined" || token === "null") {
        setLoading(false);
        return;
      }
      try {
        const { data } = await API.get("/user/details");
        if (data && data.success) {
          const userPerms = data.data.permissions || [];
          localStorage.setItem("userPermissions", JSON.stringify(userPerms));
          setPermissions(userPerms);

          // Store role name
          const userObj = data.data.user;
          let roleName = "Admin";
          if (userObj.role === "super_admin") {
            roleName = "Admin";
          } else if (userObj.roles && userObj.roles.length > 0) {
            roleName = typeof userObj.roles[0] === "object" ? userObj.roles[0].name : "Staff";
          }
          localStorage.setItem("userRoleName", roleName);
        }
      } catch (err) {
        console.error("Error fetching permissions", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [token, location.pathname]); // Refetch on route changes to ensure fresh permissions

  if (!token || token === "undefined" || token === "null") {
    return <Navigate to="/auth/login" replace />;
  }

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <h3>Loading configuration...</h3>
      </div>
    );
  }

  const isSuperAdmin = localStorage.getItem("userRoleName") === "Admin";

  // Deny access if the user has no administrative permissions (unless Super Admin)
  if (!isSuperAdmin && permissions.length === 0) {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userType");
    localStorage.removeItem("userPermissions");
    toast.error("Access Denied: You do not have permissions to access the admin portal.");
    return <Navigate to="/auth/login" replace />;
  }

  if (isSuperAdmin) {
    return <>{children}</>;
  }

  const path = location.pathname.toLowerCase();

  if (path.includes("/kyc") && !permissions.includes("kyc:read")) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path.includes("/property") && !permissions.includes("property:read")) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path.includes("/investment") && !permissions.includes("investment:read")) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path.includes("/users") && !permissions.includes("user:read")) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path.includes("/referral") && !permissions.includes("referral:read")) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path.includes("/contacts") && !permissions.includes("contact:read")) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path.includes("/roles/assignment") && !permissions.includes("assignment:read")) {
    return <Navigate to="/dashboard" replace />;
  }
  if (path.includes("/roles") && !path.includes("/roles/assignment") && !permissions.includes("role:read")) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RoleProtected;